
import * as React from 'react'
import Container from 'react-bootstrap/Container';
import { Link as LinkRouter } from 'react-router-dom'
import { Link } from '@mui/material';
import { Navbar, Nav, NavDropdown, Form, Image, Button, } from 'react-bootstrap';
import { Grid, Typography, Box } from '@mui/material'
import IosHome from 'react-ionicons/lib/IosHome'
import IosMail from 'react-ionicons/lib/IosMail'

import colors from '../constants/colors'
import logoImg from '../assets/images/logo.png'
import facebookIcon from '../assets/social_white/facebook.png'
import twitterIcon from '../assets/social_white/twitter.png'
import instagramIcon from '../assets/social_white/instagram.png'
import linkedinIcon from '../assets/social_white/linkedin.png'
const images = {
  logo: logoImg
}
import { getCurrentUser } from '../utils/currentUser'


export interface IFooterProps {

}
const Footer: React.FC<IFooterProps> = ({ }) => {
  // console.log('CURR USE', getCurrentUser())


    const browserDate = () => {
        let d = new Date();
        return d.getFullYear();
    }
    if(getCurrentUser()) {
      return (
          <div className='' style={{ backgroundColor: "#4453a6" }}>
            <link 
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css" 
  rel="stylesheet"  type='text/css'></link>
              <Grid container spacing={2} >
                  <Grid item xs={4} sm={4} >
                      <Box ml={2} >
                          <Typography color={colors.white}> &copy;Copyright 2011-{new Date().getFullYear()} - Built by <Link style={{ textDecoration: "none" }} color={colors.white} target="_black" href='http://intp.io'>INTP LLC</Link></Typography>
                      </Box>

                  </Grid>
                  <Grid item xs={2} sm={4}>
                      <Box display="flex" justifyContent="center">
                          <LinkRouter to='/terms'>
                              <Typography color={colors.white}>Terms</Typography>
                          </LinkRouter>
                          &nbsp;
                          <LinkRouter to='/privacy'>
                              <Typography color={colors.white}>Privacy</Typography>
                          </LinkRouter>
                      </Box>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                      <Box display="flex" justifyContent="flex-end" flexDirection="row" mr={2} >
                          <Link target="_black" href='https://facebook.com/movesheet'>
                              <Image src={facebookIcon} className='social-icon' />
                          </Link>
                          <Link target="_black" href='https://twitter.com/movesheet'>
                              <Image src={twitterIcon} className='social-icon' />
                          </Link>
                          <Link target="_black" href='https://instagram.com/movesheet'>
                              <Image src={instagramIcon} className='social-icon' />
                          </Link>
                          <Link target="_blank" href='https://linkedin.com/company/movesheet' >
                              <Image src={linkedinIcon} className='social-icon' />
                          </Link>
                      </Box>
                  </Grid>
              </Grid>
          </div>
      );
    }

    else return (
        <footer className="text-center text-lg-start text-muted" style={{backgroundColor: "#4453a6", color: 'white'}}>
          <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom" style={{color: 'white'}}>
            <div className="me-5 d-none d-lg-block">
              <span>Get connected with us on social networks:</span>
            </div>

            <div>
            <Link target="_black" href='https://facebook.com/movesheet'>
                              <Image src={facebookIcon} className='social-icon' />
                          </Link>
                          <Link target="_black" href='https://twitter.com/movesheet'>
                              <Image src={twitterIcon} className='social-icon' />
                          </Link>
                          <Link target="_black" href='https://instagram.com/movesheet'>
                              <Image src={instagramIcon} className='social-icon' />
                          </Link>
                          <Link target="_blank" href='https://linkedin.com/company/movesheet' >
                              <Image src={linkedinIcon} className='social-icon' />
                          </Link>
            </div>
          </section>

          <section className="" style={{color: 'white'}}>
            <div className="container text-center text-md-start mt-5">
              <div className="row mt-3">
                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">
                    <i className="fas fa-gem me-3 text-secondary"></i>MoveSheet
                  </h6>
                  <p>
                    <Image style={{ width: 120 }} src={images.logo}></Image>
                  </p>
                </div>

                <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">
                    Useful Links
                  </h6>
                  <p>
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.atlaslabor&hl=en_US" className="text-reset">Android App</a>
                  </p>
                  <p>
                    <a target="_blank" href="https://apps.apple.com/us/app/movesheet/id1437078036" className="text-reset">iPhone App</a>
                  </p>
                  <p>
                    <a href="/login" className="text-reset">Login</a>
                  </p>
                  <p>
                    <a href="/register" className="text-reset">Register</a>
                  </p>
                </div>

                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">
                    Policy
                  </h6>
                  <p>
                    <a href="/terms" className="text-reset">Terms</a>
                  </p>
                  <p>
                    <a href="/privacy" className="text-reset">Privacy</a>
                  </p>
                </div>

                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                  <p><IosHome color="white" /> Denver, CO 80202, US</p>
                  <p>
                    <IosMail color="white" /> info@movesheet.com
                  </p>
                </div>
              </div>
            </div>
          </section>

        <div className="text-center p-4" style={{ backgroundColor: "#4453a6", color: 'white' }} /*style="background-color: rgba(0, 0, 0, 0.025);"*/>
          © 2011-{new Date().getFullYear()} Copyright&nbsp;
          <a className="text-reset fw-bold" href="http://intp.io">INTP LLC</a>
        </div>
      </footer>
    );

}

export default Footer;
export { Footer }